import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import useDecode from 'hooks/useDecode';
import DeclaracionJuradaViolenciaGenero from './DeclaracionJuradaViolenciaGenero';
import useGetDeclaracionJuradaViolenciaGeneroByID from 'services/record/DeclaracionJuradaViolenciaGenero/useGetDeclaracionJuradaViolenciaGeneroByID';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialDeclaracionJuradaViolenciaGenero = () => {
    const decoded = useDecode("token");
    const [data, setData] = useState(null);
    const navigate = useNavigate()
    const { dataGetDeclaracionJuradaViolenciaGeneroByID, errorGetDeclaracionJuradaViolenciaGeneroByID, getDeclaracionJuradaViolenciaGeneroByID, loadingGetDeclaracionJuradaViolenciaGeneroByID, successGetDeclaracionJuradaViolenciaGeneroByID } = useGetDeclaracionJuradaViolenciaGeneroByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const userId = decoded.extension_id;
            const prestacionId = idprestacion.split('_')[1];
            const formId = idform;

            getDeclaracionJuradaViolenciaGeneroByID(userId, prestacionId, formId, setData);
        }
    }, []);

    return (
        <div>
            <PageMenu title={'Declaración jurada fuerza mayor y violencia de género'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetDeclaracionJuradaViolenciaGeneroByID ?
                    <Loader activeLoader={true} label="Cargando Formulario"></Loader>
                    :
                    <DeclaracionJuradaViolenciaGenero dataUser={data} info={false} />
            }




        </div>
    )
}

export default HistorialDeclaracionJuradaViolenciaGenero